import React, { Component } from 'react';
import { push } from 'redux-first-history';
import PropTypes from 'prop-types';
import { doesInclude } from '../../Util';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { ImprivataIdPush as ImprivataIdPushComponent } from '@imprivata/nucleus';
import { PushProtocols } from '../../constants/clientProtocols';
import LogoutStyled from '../shared/LogoutStyled';
import RememberMe from '../shared/RememberMe';
import headerImage from '../../images/phone.svg';
import MoreOptions from '../shared/MoreOptions';

import './ImprivataIdPush.scss';


/**
 * Displays a waiting screen while the user accepts the push on their mobile device.
 *
 * @export
 * @class ImprivataIdPush
 * @extends {Component}
 */
export class ImprivataIdPush extends Component {
  /**
   * The allowed properties for the ImprivataIdPush component
   * @param {array} availableModalities available modalities to switch to
   */
  static propTypes = {
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    deviceList: PropTypes.arrayOf(PropTypes.object),
    serverState: PropTypes.object,
    isDeviceManagementWorkflow: PropTypes.bool,
    retryPush: PropTypes.func,
    matchingNumber: PropTypes.string,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
  };
  static defaultProps = {
    availableModalities: [],
    serverState: null,
    isDeviceManagementWorkflow: false,
    deviceList: [],
    useCustomUX: false,
  };

  buildCapabilityList = (capability) => {
    let capabilityList = '';
    capabilityList = capabilityList.concat(capability);
    return capabilityList;
  };

  render() {
    const {
      availableModalities,
      capabilities,
      deviceList,
      isDeviceManagementWorkflow,
      retryPush,
      selfServiceEnabled,
      serverState,
      startDeviceManagementWorkflow,
      startManualIIDToken,
      updateDeviceList,
      viewDeviceList,
      matchingNumber,
      useCustomUX,
    } = this.props;

    const hasTempCodeMessage = serverState &&
      serverState.temporaryCodeAllowed &&
      !serverState.temporaryCodeAvailable;
    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'iid') : [];
    let moreOptions = (modalities.length > 0) ? <MoreOptions currentModality='iid' /> : null;
    const logoutStyle = useCustomUX ? 'black' : 'white';
    if (hasTempCodeMessage && moreOptions === null) {
      moreOptions = <div className='Temp-code-text'>Alternatively, call your help desk for a temp code</div>;
    }
    let capabilitiesToRender = '';
    // Check if Fortuna
    try {
      capabilitiesToRender = capabilities.DeviceManagement[0].functions.map(this.buildCapabilityList);
    }
    catch (error) {
      try {
        // Check if Europa
        if (capabilities.DeviceManagement.version != null) {
          capabilitiesToRender = 'enroll';
        }
      }
      catch (error) {
        capabilitiesToRender = '';
      }
    }

    let ListOfDevices = [];
    try {
      if (deviceList.length > 0) {
        ListOfDevices = deviceList;
      }
      else if (serverState.modalities != null && serverState.modalities.optionalImprivataIdAuthenticationState != null) {
        // we goota move this outta here, cannot test
        const authState = PushProtocols.PushAuthState.getValue(serverState.modalities.optionalImprivataIdAuthenticationState);
        if (authState.imprivataIdDeviceList) {
          ListOfDevices = authState.imprivataIdDeviceList;
          updateDeviceList(ListOfDevices);
        }
      }
    }
    catch (error) {
      ListOfDevices = [];
    }

    const deviceNameToShow = ListOfDevices[0] != null ? ListOfDevices[0].displayName : 'your device';

    if (selfServiceEnabled) {
      return (
        <div className='content-body'>
          <ImprivataIdPushComponent
            headerImage={headerImage}
            headerTitle='Imprivata ID'
            deviceDescription={matchingNumber ?
              (
                <span>Approve notification on<br /> <strong>{deviceNameToShow}</strong><br />
                  and enter this code</span>
              ) : (
                <span>Approve notification on <br /> <strong>{deviceNameToShow}</strong></span>
              )
            }
            matchingNumber={matchingNumber}
            manageDeviceLink={isDeviceManagementWorkflow || !doesInclude(capabilitiesToRender, 'list') ?
              null : viewDeviceList
            }
            enrollDeviceLink={isDeviceManagementWorkflow || !doesInclude(capabilitiesToRender, 'enroll') ?
              null : startDeviceManagementWorkflow
            }
            retryText="Didn't get a notification?"
            onRetryClick={retryPush}
            startManualIIDToken={startManualIIDToken}
            logoutComponent={<LogoutStyled type={logoutStyle} />}
            moreOptionsLink={moreOptions}
            footer={<RememberMe />}
            useCustomUX={useCustomUX}
          />
        </div>
      );
    }
    else {
      return (
        <div className='content-body'>
          <ImprivataIdPushComponent
            headerImage={headerImage}
            headerTitle='Imprivata ID'
            deviceDescription={matchingNumber ?
              (
                <span>Approve notification on<br /> <strong>{deviceNameToShow}</strong><br />
                  and enter this code</span>
              ) : (
                <span>Approve notification on <br /> <strong>{deviceNameToShow}</strong></span>
              )
            }
            matchingNumber={matchingNumber}
            retryText="Didn't get a notification?"
            onRetryClick={retryPush}
            startManualIIDToken={startManualIIDToken}
            logoutComponent={<LogoutStyled type={logoutStyle} />}
            moreOptionsLink={moreOptions}
            footer={<RememberMe />}
            useCustomUX={useCustomUX}
          />
        </div>
      );
    }
  }
}


const mapStateToProps = (state) => {
  const {
    availableModalities, serverState, capabilities, deviceList, isDeviceManagementWorkflow, selfServiceEnabled,
    matchingNumber, useCustomUX, isClinicalWorkflow,
  } = state.login;
  return {
    availableModalities,
    serverState,
    capabilities,
    deviceList,
    isDeviceManagementWorkflow,
    selfServiceEnabled,
    matchingNumber,
    useCustomUX,
    isClinicalWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateDeviceList: (list) => {
      dispatch(actions.updateDeviceList(list) );
    },
    viewDeviceList: () => {
      dispatch(actions.startIgnoreTimeout() );
      dispatch(push('/devicelist') );
    },
    startDeviceManagementWorkflow: () => {
      dispatch(actions.startDeviceManagementSession() );
      dispatch(actions.moreOptionsChooseModality(false) );
      dispatch(actions.startIgnoreTimeout() );
      dispatch(push('/choosemodality') );
    },
    returnToChooseModality: () => {
      dispatch(actions.moreOptionsChooseModality(true) );
      dispatch(push('/choosemodality') );
    },
    retryPush: () => {
      dispatch(actions.initiateImprivataIdPush() );
    },
    startManualIIDToken: () => {
      dispatch(push('/iid-manual') );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ImprivataIdPush);
